import React, { useEffect, useRef, useState } from "react";

function Agreement() {
  function RenderTableColumn({ totalColumn }) {
    // const totalColumn = totalColumn ? totalColumn : 0;
    const allAgreement = [
      {
        beforeFlight: [
          "ตรวจสอบว่าอากาศยานอยู่ในสภาพที่สามารถทำการบินได้อย่างปลอดภัย ซึ่งรวมถึงตัวอากาศยานและระบบควบคุมอากาศยาน",
          "ได้รับอนุญาตจากเจ้าของพื้นที่ที่จะทำการบิน",
          "ทำการศึกษาพื้นที่และชั้นของห้วงอากาศที่จะทำการบิน",
          "มีแผนฉุกเฉิน รวมถึงแผนสำหรับกรณีเกิดอุบัติเหตุ การรักษาพยาบาล และ การแก้ปัญหากรณีไม่สามารถบังคับอากาศยานได้",
          ""
        ],
        whileFlight: [
          "ห้ามทำการบินในลักษณะที่อาจก่อให้เกิดอันตรายต่อชีวิต ร่างกาย ทรัพย์สิน และรบกวนความสงบสุขของบุคคลอื่น",
          "ห้ามทำการบินเข้าไปในบริเวณเขตห้าม เขตกำกัด และเขตอันตรายตามที่ประกาศในเอกสารแถลงข่าวการบินของประเทศไทย (Aeronautical Information Publication - Thailand หรือ AIP - Thailand) รวมทั้งสถานที่ราชการ หน่วยงานของรัฐ โรงพยาบาล เว้นแต่จะได้รับอนุญาตจากหน่วยงานเจ้าของพื้นที่",
          "แนวการบินขึ้นลงของอากาศยานจะต้องไม่มีสิ่งกีดขวาง",
          "ผู้บังคับหรือปล่อยอากาศยานต้องสามารถมองเห็นอากาศยานได้ตลอดเวลาที่ทำการบิน และห้ามทำการบังคับอากาศยานโดยอาศัยชุดกล้องบนอากาศยานหรืออุปกรณ์อื่นที่มีลักษณะใกล้เคียง",
          "ต้องทำการบินในระหว่างเวลาพระอาทิตย์ขึ้นถึงพระอาทิตย์ตก ซึ่งสามารถมองเห็นอากาศยานได้อย่างชัดเจน",
          "ห้ามทำการบินเข้าใกล้หรือเข้าไปในเมฆ",
          "ห้ามทำการบินภายในระยะเก้ากิโลเมตร (ห้าไมล์ทะเล) จากสนามบินหรือที่ขึ้นลงชั่วคราวของอากาศยาน เว้นแต่ได้รับอนุญาตจากเจ้าของหรือผู้ดำเนินการสนามบินหรือที่ขึ้นลงชั่วคราว",
          "ห้ามทำการบินโดยใช้ความสูงเกินเก้าสิบเมตร (สามร้อยฟุต) เหนือพื้นดิน",
          "ห้ามทำการบินเหนือเมือง หมู่บ้าน ชุมชน หรือพื้นที่ที่มีคนมาชุมนุมอยู่",
        ],
      },
      {
        beforeFlight: [
          "มีการบำรุงรักษาตามคู่มือของผู้ผลิต",
          "มีความรู้ความชำนาญในการบังคับอากาศยานและระบบของอากาศยาน",
          "นำหนังสือหรือสำเนาหนังสือการขึ้นทะเบียนติดตัวตลอดเวลาที่ทำการบิน",
          "มีอุปกรณ์ดับเพลิงที่สามารถใช้งานได้ติดตัวตลอดเวลาที่ทำการบิน",
          "มีการทำประกันภัยสำหรับความเสียหายอันเกิดแก่ร่างกาย ชีวิต ตลอดจนทรัพย์สินของบุคคลที่สาม วงเงินประกันไม่ต่ำกว่าหนึ่งล้านบาทต่อครั้ง",
        ],
        whileFlight: [
          "ห้ามทำการบินโดยมีระยะห่างในแนวราบกับบุคคล ยานพาหนะ สิ่งก่อสร้าง อาคาร ที่ไม่เกี่ยวข้องกับการปฏิบัติการบินน้อยกว่าห้าสิบเมตร (หนึ่งร้อยห้าสิบฟุต)",
          "เมื่อมีอุบัติเหตุเกิดขึ้นแก่อากาศยาน ให้ผู้บังคับหรือปล่อยอากาศยานแจ้งอุบัติเหตุนั้นต่อพนักงานเจ้าหน้าที่โดยไม่ชักช้า",
        ],
      },
      {
        beforeFlight: [
          "มีการบำรุงรักษาตามคู่มือของผู้ผลิต",
          "นำหนังสือหรือสำเนาหนังสือการขึ้นทะเบียนติดตัวตลอดเวลาที่ทำการบิน",
          "ตรวจสอบว่า กรมธรรม์ประกันภัยสำหรับความเสียหายอันเกิดแก่ร่างกาย ชีวิต ตลอดจนทรัพย์สินของบุคคลที่สามตามวงเงินประกันที่กำหนด ยังมีผลอยู่",
          "",
          ""
        ],
        whileFlight: [
          "ห้ามทำการบินโดยมีระยะห่างในแนวราบกับบุคคล ยานพาหนะ สิ่งก่อสร้าง อาคาร ที่ไม่เกี่ยวข้องกับการปฏิบัติการบินน้อยกว่าหนึ่งร้อยห้าสิบเมตร (ห้าร้อยฟุต)",
          "เมื่อมีอุบัติเหตุหรืออุบัติการณ์เกิดขึ้นแก่อากาศยานที่ควบคุมการบินจากภายนอก ให้ผู้บังคับหรือปล่อยอากาศยานที่ควบคุมแจ้งเหตุตามช่องทางที่กำหนดโดยไม่ชักช้า ซึ่งต้องไม่เกิน 48 ชม.",
        ],
      },
    ];
    return (
      <div style={{ marginTop: "25px" }}>
        {/* {Array.from({ length: totalColumn }, (_, i) => (
          <div style={{ marginTop: "50px" }} key={i}>
            <h3
              style={{
                textAlign: "center",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              เงื่อนไขชุดที่ {i + 1}
            </h3>
            <h4 style={{ textAlign: "left", fontWeight: "bold" }}>
              ก่อนทำการบิน
            </h4>
            <ul>
              {allAgreement[i % allAgreement.length].beforeFlight.map(
                (item, index) => (
                  <li
                    style={{ textJustify: "inter-word", fontSize: "17px" }}
                    key={index}
                  >
                    - {item}
                  </li>
                )
              )}
            </ul>
            <h4 style={{ textAlign: "left", fontWeight: "bold" }}>
              ขณะทำการบิน
            </h4>
            <ul>
              {allAgreement[i % allAgreement.length].whileFlight.map(
                (item, index) => (
                  <li
                    style={{ textJustify: "inter-word", fontSize: "17px" }}
                    key={index}
                  >
                    - {item}
                  </li>
                )
              )}
            </ul>
          </div>
        ))} */}
        <table style={{ width: "100%", marginTop:"50px" }}>
          <thead>
            <tr style={{ textAlign: "center" }}>
              {Array.from({ length: totalColumn }, (_, i) => (
                <th style={{ width: "33%", height:"50px" }} key={i}>
                  เงื่อนไขชุดที่ {i + 1}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: totalColumn }, (_, i) => (
              <td key={i} style={{ width: "33%", borderRight:i+1 == totalColumn ? "":"1px solid black" }}>
                {allAgreement[i].beforeFlight.map((content, index) => (
                  <tr
                    style={{ height: `${50 * totalColumn}px`}}
                    key={index}
                  >
                    <p style={{padding:"0px 10px"}}>{content}</p>
                   
                  </tr>
                ))}
              </td>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div
      style={{
        height: "93.25vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "75%",
          height: "100%",
          backgroundColor: "white",
          overflow: "scroll",
          scrollbarWidth: "none",
        }}
      >
        <div style={{ padding: "75px 10px" }}>
          <h3 style={{textAlign:"center", textDecoration:"underline"}}>ข้อมูลเงื่อนไขในการบังคับหรือปล่อยอากาศยานซึ่งไม่มีนักบิน</h3>
          {/* <h2 style={{ textAlign: "center", fontWeight: "bold" }}>
            ข้อมูลเงื่อนไขในการบังคับหรือปล่อยอากาศยานซึ่งไม่มีนักบิน
          </h2>
          <RenderTableColumn totalColumn={3}></RenderTableColumn> */}

          <RenderTableColumn totalColumn={3} />
        </div>
      </div>
    </div>
  );
}

export default Agreement;
